.custom-select-sm{padding-top:0;padding-bottom:0}
/*# sourceMappingURL=simple-multi-select.component-UHZFB5JP.css.map */
